import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import CampaignDetail from './CampaignDetail'
import CampaignVouchers from './CampaignVouchers'

const CampaignShow = () => {
  const {
    props: { campaign, voucherByType },
  } = usePage()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CampaignDetail campaign={campaign} voucherByType={voucherByType} />
      </Grid>

      <Grid item xs={12}>
        <CampaignVouchers />
      </Grid>
    </Grid>
  )
}

export default CampaignShow
